<template>
    <div class="grid h-auto w-full flex-grow grid-cols-2 gap-2 p-4">
        <div
            v-for="blockType in blockTypes"
            :key="blockType"
            class="flex h-20 w-full cursor-pointer items-center justify-center rounded-md bg-slate-100 text-sm uppercase"
            @click="addBlock(blockType)"
        >
            {{ blockType.split('-').join(' ') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { BlockType, blockTypes } from '@builder/types'
import { useEventBus } from '@vueuse/core'

const eventBus = useEventBus('blockActions')

const addBlock = (blockType: BlockType) => {
    eventBus.emit({
        type: 'addBlock',
        block: blockType,
    })
}
</script>
